import React, { useEffect } from "react";

import { Box, Typography, Paper } from "@mui/material";
import {AuthenticatedTemplate, UnauthenticatedTemplate} from "@azure/msal-react";

import LoginButton from "../components/auth/LoginButton";
import { useNavigate } from "react-router-dom";
import { Loader } from "lucide-react";

function Login() {
  const navigate = useNavigate();

   const RedirectToDashboard = () => {
    useEffect(() => {
      navigate('/dashboard');
    }, []);
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <Loader size={40} className="animate-spin text-blue-600" />
      </div>
    );
  };


  return (
    <>
    <AuthenticatedTemplate>
      <RedirectToDashboard />
    </AuthenticatedTemplate>
    <UnauthenticatedTemplate>
    
          <Box
            sx={{
              minHeight: "100vh",

              display: "flex",

              alignItems: "center",

              justifyContent: "center",

              background: "#f8fafc",
            }}
          >
            <Paper
              elevation={3}
              sx={{
                width: 400,

                p: 5,

                borderRadius: 3,

                textAlign: "center",
              }}
            >
              <Typography variant="h4" fontWeight={700} color="#0f172a" mb={1}>
                IT Service Desk Portal
              </Typography>

              <Typography color="#64748b" mb={4}>
                Sign in using your Microsoft account
              </Typography>

              <LoginButton />
            </Paper>
          </Box>

    </UnauthenticatedTemplate>
    </>
  );
}

export default Login;
